var map = {
	"./1.png": "YTOG",
	"./10.png": "SiO8",
	"./11.png": "xgX3",
	"./12.png": "jELE",
	"./13.png": "mvY1",
	"./14.png": "BkY2",
	"./15.png": "HEIl",
	"./16.png": "71mN",
	"./17.png": "r7ri",
	"./18.png": "1m99",
	"./19.png": "SHfi",
	"./2.png": "sk1k",
	"./20.png": "dcEc",
	"./21.png": "h5m2",
	"./22.png": "hBcr",
	"./23.png": "9cEc",
	"./24.png": "B9CS",
	"./25.png": "QEmU",
	"./26.png": "PvHm",
	"./27.png": "ETZb",
	"./28.png": "n2/W",
	"./29.png": "SBKy",
	"./3.png": "CqPK",
	"./30.png": "JjcU",
	"./31.png": "Pj6T",
	"./32.png": "UcMa",
	"./33.png": "skLL",
	"./34.png": "Ks8J",
	"./35.png": "adzg",
	"./36.png": "gFPl",
	"./37.png": "0JVf",
	"./38.png": "CMiB",
	"./39.png": "N2GC",
	"./4.png": "zIsM",
	"./40.png": "vc6t",
	"./41.png": "lVvu",
	"./42.png": "gbrI",
	"./43.png": "Z0T/",
	"./44.png": "2/ur",
	"./45.png": "bncx",
	"./46.png": "PQlY",
	"./47.png": "mYOa",
	"./48.png": "l1Al",
	"./5.png": "At5N",
	"./6.png": "1Juq",
	"./7.png": "IyAo",
	"./8.png": "9eda",
	"./9.png": "rTTT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2yBr";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big nonrecursive \.png$
// module id = 2yBr
// module chunks = 1